@if (paymentMessage$$(); as message) {
    <p class="account-credits__payment" [class.account-credits__payment--failed]="!message.ok">{{ message.text }}</p>
}
@for (domain of domains$$(); track domain[domainCreditsListDto.domainAUserGuid]) {
    <button
        type="button"
        class="account-credits__row"
        [class.account-credits__row--selected]="domain[domainCreditsListDto.domainAUserGuid] === selected$$()"
        (click)="emit_select(domain)"
    >
        <span class="account-credits__name">
            {{ domain[domainCreditsListDto.name] }}
            @if (domain[domainCreditsListDto.isOwner]) {
                <small>{{ _text.owner }}</small>
            }
            @if (state_label(domain)) {
                <small class="account-credits__state">{{ state_label(domain) }}</small>
            }
        </span>
        <span class="account-credits__num" [class.account-credits__negative]="(domain[domainCreditsListDto.creditBalance] ?? 0) < 0">
            {{ _text.balance }} {{ number_format(domain[domainCreditsListDto.creditBalance]) }}
        </span>
    </button>
    @if (domain[domainCreditsListDto.domainAUserGuid] === selected$$()) {
        <app-domain-credits-panel [dauGuid]="selected$$()" (changed)="emit_changed($event)" />
    }
}
